import { render, staticRenderFns } from "./price-market-price-futures.vue?vue&type=template&id=4ac8dffd&scoped=true&"
import script from "./price-market-price-futures.vue?vue&type=script&lang=js&"
export * from "./price-market-price-futures.vue?vue&type=script&lang=js&"
import style0 from "./price-market-price-futures.vue?vue&type=style&index=0&id=4ac8dffd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac8dffd",
  null
  
)

export default component.exports